import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import quotes_json from "../data/quotes.json";
import "../styles/App.css";


const Quotes = () => {
    const currentLanguageVal = localStorage.getItem("language");
    const currentLanguage = currentLanguageVal ? currentLanguageVal : "en";
    const items = quotes_json;
    const isMobile = window.innerWidth <= 768;

  return (
    <Carousel
      autoPlay={!isMobile}
      interval={3000}
      infiniteLoop
      showThumbs={false}
      showStatus={false}
      showIndicators={false}
      stopOnHover={!isMobile}
      swipeable
      emulateTouch
      verticalSwipe="natural"
      dynamicHeight={false}
      className="carousel-container"
      preventMovementUntilSwipeScrollTolerance={true}
      swipeScrollTolerance={50}
      renderArrowPrev={(onClickHandler, hasPrev, label) =>
        hasPrev && (
        <button type="button" onClick={onClickHandler} title={label} className="custom-arrow prev">
            ‹
        </button>
        )
        }
        renderArrowNext={(onClickHandler, hasNext, label) =>
            hasNext && (
            <button type="button" onClick={onClickHandler} title={label} className="custom-arrow next">
                ›
            </button>
            )
        }
    >

      {items.map((item) => {
        let shlok =currentLanguage === "en" ? item.shlok : item.shlokHindi;
        let meaning =currentLanguage === "en" ? item.meaning : item.meaningHindi;
        return (<div key={item.value}>
            <p className="shlok-text">{shlok}</p>
            <p className="shlok-meaning">{meaning}</p>
        </div>)
        })}
    </Carousel>
  );
};

export default Quotes;
